import { useEffect } from 'react';

import { useAnimate } from 'motion/react';

import Spacer from '@helsenorge/designsystem-react/components/Spacer/Spacer';
import { useIsMobileBreakpoint } from '@helsenorge/designsystem-react/hooks/useIsMobileBreakpoint';

import LoadingText from '../../loading-text';

import styles from './styles.module.scss';

interface SummaryLoaderProps {
  messages: string[];
}

const SummaryLoader: React.FC<SummaryLoaderProps> = props => {
  const isMobile = useIsMobileBreakpoint();
  const svgSize = isMobile ? 14 : 19;
  const [scope, animate] = useAnimate();

  useEffect(() => {
    if (!scope.current) {
      return;
    }

    animate(scope.current, { rotate: 360 }, { duration: 1.3, ease: 'linear', repeat: Infinity });
  }, [animate, scope]);

  return (
    <div className={styles['summary-loader']}>
      <svg
        ref={scope}
        className={styles['summary-loader__svg']}
        data-testid="summary-loader-spinner"
        width={svgSize}
        height={svgSize}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {isMobile ? (
          <path d="M1 7a6 6 0 1 1 6 6" strokeWidth="2" strokeLinecap="round" />
        ) : (
          <path d="M1.5 9.5a8 8 0 1 1 8 8" strokeWidth="2.3" strokeLinecap="round" />
        )}
      </svg>
      <Spacer />
      <LoadingText messages={props.messages} className={styles['summary-loader__text']} interval={2200} />
    </div>
  );
};

export default SummaryLoader;
